import { useMutation } from '@tanstack/react-query'
import { toRnbApiError } from 'shared'
import { useFetch } from './useFetch'
import { useLogger } from './useLogger'
import { logRnbErrorCode } from './utils/rnbErrorLog'

type Params = {
  id: string
  active: boolean
}

export function usePromotionActivation() {
  const { fetcherWrapper } = useFetch()
  const { logger } = useLogger()

  const mutation = async (params: Params) => {
    const { id, active } = params

    const url = new URL(
      `/api/proxy/rnb/pvt/calculatorConfiguration/${id}`,
      window.location.origin
    )

    try {
      return await fetcherWrapper(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([
          {
            op: 'replace',
            path: '/isActive',
            value: active,
          },
        ]),
      })
    } catch (error) {
      const apiError = await toRnbApiError(error)

      logRnbErrorCode({ error: apiError, url: url.toString(), logger })

      throw apiError
    }
  }

  const { mutate: update } = useMutation({ mutationFn: mutation })

  return {
    update,
  }
}
